module.exports = __webpack_public_path__ + "img/rongyu.141d4dba.png";